<template>
  <div class="xcbdCls">
    <!-- <div style="width:100%;" class="flex-XY-center">
      <img src="@/assets/picture/xcbdTitle.png" alt="" width="115" />
    </div>
    <van-sticky>
      <div class="navCls flex">
        <div
          v-for="(item, index) in navTitle"
          :key="index"
          @click="movePositionFn(item.id)"
        >
          {{ item.label }}
        </div>
      </div>
    </van-sticky>

    <div
      class="contentPanel"
      v-for="(item, index) in navTitle"
      :key="index"
      :id="item.id"
    >
      <div
        :style="{ position: 'sticky', top: navHeight + 'px', left: 0 }"
        class="newsTitle flex-between"
      >
        <div><span>▌</span>{{ item.label }}</div>
        <p @click="moreFn(item.id)">更多</p>
      </div>
      <div class="newsPanel" @click="detailContentFn()">
        <div class="newsContentBox flex">
          <div>
            <div>
              区委、开发区党工主题教育读书开班啊实打实大师多阿打算asdasada
            </div>
            <p>记者：刘德华，张晓雪友</p>
            <p>2023-9-14</p>
          </div>
          <div>
            <img src="@/assets/picture/111.png" width="100%" alt="" />
          </div>
        </div>
      </div>
    </div> -->

    <div class="iframeBox">
      <!-- <img src="@/assets/picture/xwbd1(2).jpg" alt="" width="100%" height="100%"> -->
      <!-- <iframe
        id="my-iframe"
        src="https://share.blnews.com.cn/webDetails/subject?id=1208385&tenantId=18&uid=5d9b167ba61d5607111bc0e8"
        frameborder="0"
      ></iframe> -->
      <!-- <iframe
        id="my-iframe"
        src="https://share.blnews.com.cn/webDetails/subject?id=14199481&tenantId=18&uid=5dd666682096f07d11f92b16"
        frameborder="0"
      ></iframe> -->
      <iframe
        id="my-iframe"
        src="https://share.blnews.com.cn/webDetails/sonPage?id=19072147&tenantId=18&uid=626b575bfe3fc11bc94ed722&groupId=2196673"
        frameborder="0"
      ></iframe>

    </div>
  </div>
</template>

<script>
export default {
  name: 'xcbd',
  data() {
    return {
      navTitle: [
        { label: '新闻要点', id: 'xwyd' },
        { label: '一线动态', id: 'yxdt' },
        { label: '媒体关注', id: 'mtgz' },
        { label: '一把手谈', id: 'ybst' },
        { label: '"六促六优"先锋榜（第一期）', id: 'dyc' },
        { label: '"六促六优"先锋榜（第二期）', id: 'deq' },
      ],
      navHeight: '',
    }
  },
  props: {},
  components: {},
  created() {},
  mounted() {
    // let dom2 = document.querySelector('.navCls')
    // this.navHeight = dom2.offsetHeight
  },
  methods: {
    movePositionFn(value) {
      let dom1 = document.getElementById(value) //移动的目标盒子
      let top = dom1.offsetTop //需要移动的距离
      window.scrollTo({
        top: top - this.navHeight,
        behavior: 'smooth', //平滑移动
      })
    },
    moreFn(value) {
      this.$router.push({
        path: '/xcbdMore',
        query: {
          id: value,
        },
      })
    },
    detailContentFn() {
      this.$router.push({
        path: '/xcbdDetail',
        query: {},
      })
    },
  },
}
</script>

<style scoped>
.xcbdCls {
  /* background-color: #f1f5fb; */
  /* box-sizing: border-box; */
  width: 100%;
  height: 100%;
}

.xcbdCls h2 {
  color: #d4a6cb;
  font-size: 30px;
}
.navCls {
  padding: 10px;
  flex-wrap: wrap;
  background-color: #ffffff;
  color: #fff;
}

.navCls div {
  margin: 5px 5px;
  padding: 5px;
  background-color: #a1d4bf;
  border-radius: 20px;
  font-size: 14px;
}
.contentPanel {
  padding: 0 10px;
}
.newsTitle {
  margin: 10px 0;
  font-weight: 700;
  color: #000;
  background-color: #fff;
}
.newsTitle span {
  color: #a1d4bf;
}
.newsTitle p {
  margin-top: 5px;
  font-size: 12px;
  color: #999;
}
.newsPanel {
  color: #000;
  padding: 10px;
  border-bottom: 1px solid #ccc4c4;
}
.newsContentBox {
  height: 100px;
}
.newsContentBox div:nth-child(1) {
  flex: 1;
  text-align: left;
}
.newsContentBox div:nth-child(1) div {
  height: 40%;
  width: 100%;
  margin-bottom: 30px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
.newsContentBox div:nth-child(1) p {
  font-size: 12px;
  color: #999;
}
.newsContentBox div:nth-child(2) {
  width: 100px;
  margin-left: 20px;
}
.iframeBox {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: #eee;
}
iframe {
  width: calc(100% + 20px);
  height: 100%;
}
/* xsb-guide-wrap */
</style>



// WEBPACK FOOTER //
// src/components/xcbd.vue